import React from "react";
import { SearchableSelect, type SearchableSelectOption } from "@racoon/ui";

interface Props {
  value: string;
  options: SearchableSelectOption[];
  allLabel: string;
  onChange: (id: string) => void;
}

export const ChartEntitySelect: React.FC<Props> = ({ value, options, allLabel, onChange }) => {
  return (
    <SearchableSelect
      value={value}
      options={options}
      clearOption={{ id: "all", name: allLabel }}
      onChange={onChange}
      triggerClassName="h-9 min-w-[220px] rounded-lg px-3 py-2"
    />
  );
};
